<template>
  <v-card>
    <v-card-title>
      Season {{ year }}
    </v-card-title>
    <v-card-text class="d-flex flex-column" style="gap: 10px;">

      <div class="d-flex justify-space-between align-center">
        <p class="p-0 mb-0" style="font-size: 14px; color: #000;">Corridor Awareness Assessment</p>
        <v-btn
            color="primary"
            v-if="corridorAwarenessAssessment"
            small
            dense
            :to="{name: 'EditCorridorAwareness', query: { uuid: customer.uuid, assessmentUuid: corridorAwarenessAssessment.uuid } }"
        >
          {{$t('edit')}}
        </v-btn>
        <v-btn
            color="primary"
            v-else
            small
            dense
            :to="{name: 'EditCorridorAwareness', query: { uuid: customer.uuid } }"
        >
          {{$t('new')}}
        </v-btn>
      </div>
      <div class="d-flex justify-space-between align-center">
        <p class="p-0 mb-0" style="font-size: 14px; color: #000;">Field Survey Assessment</p>
        <v-btn
            color="primary"
            v-if="fieldSurveyAssessment"
            small
            dense
            :to="{ name: 'EcoExistBwFieldSurvey', query: { uuid: customer.uuid, assessmentUuid: fieldSurveyAssessment.uuid } }"
        >
          {{$t('edit')}}
        </v-btn>

        <v-btn
            color="primary"
            v-else
            small
            dense
            :to="{name: 'EcoExistBwFieldSurvey', query: { uuid: customer.uuid, farmUuid: newFieldUuid } }"
        >
          {{$t('new')}}
        </v-btn>
      </div>
      <div class="d-flex justify-space-between align-center">
        <p class="p-0 mb-0" style="font-size: 14px; color: #000;">Portion Survey Assessment</p>
        <v-btn
            color="primary"
            v-if="portionSurveyAssessment"
            small
            dense
            :to="{name: 'CreateCaNonCa', query: { uuid: customer.uuid, fieldUuid: newFieldUuid, assessmentUuid: portionSurveyAssessment.uuid } }"
        >
          {{$t('edit')}}
        </v-btn>

        <v-btn
            color="primary"
            v-else
            small
            dense
            :to="{name: 'CreateCaNonCa', query: { uuid: customer.uuid, fieldUuid: newFieldUuid } }"
        >
          {{$t('new')}}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'SeasonAssessment',
  props: {
    year: Number,
    customer: Object,
  },
  data: () => ({
    newFieldUuid: uuidv4(),
  }),
  computed: {
    corridorAwarenessAssessment() {
      return this.customer ? this.$store.getters.customerAssessmentYear(this.customer.uuid, 'CorridorAwarenessAssessment', this.year) : null;
    },
    fieldSurveyAssessment() {
      return this.customer ? this.$store.getters.customerAssessmentYear(this.customer.uuid, 'FieldSurvey', this.year) : null;
    },
    portionSurveyAssessment() {
      return this.customer ? this.$store.getters.customerAssessmentYear(this.customer.uuid, 'PortionSurvey', this.year) : null;
    },
  },
}
</script>